import { useState } from "react";
import { Progress, Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import PropTypes from "prop-types";

import { Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";

const Component = ({ aspect = 1, onChange, value, uploadOptions }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { progress } = state;

	const handleUpload = (options) => {
		const { file } = options;

		if (Types.uploadImageFormats.indexOf(file.type) >= 0) {
			// if (file.size < parseInt(process.env.REACT_APP_IMAGE_SIZE_LIMIT)) {
				onChange(file);
			// } else {
			// 	message.error(Resources.uploadErros?.size);
			// }
		} else {
			message.error(Resources.uploadErros?.extension);
		}
	};

	const propUploadOpts = uploadOptions ? { ...uploadOptions } : {};

	const uploadOpt = {
		//listType: 'picture-card',
		showUploadList: true,
		customRequest: handleUpload,
	};

	return aspect === 0 ? (
		<Upload
			{...uploadOpt}
			{...propUploadOpts}
			className="sp-upload-image"
		>
			{progress > 0 ? (
				<>
					<span className="uploading">{Resources.upload}</span>
					<Progress
						percent={progress}
						showInfo={false}
					/>
				</>
			) : !!value ? (
				<img
					src={value}
					alt="avatar"
					className="image"
				/>
			) : (
				<i className="fa fa-plus icon" />
			)}
		</Upload>
	) : (
		<ImgCrop
			aspect={aspect}
			rotate
			modalOk={Resources.confirm}
			modalCancel={Resources.cancel}
			modalTitle={`${Resources.cut} ${Resources.image}`}
			modalClassName="ant-modal-wrap-rtl"
		>
			<Upload
				{...uploadOpt}
				{...propUploadOpts}
				className="sp-upload-image"
			>
				{progress > 0 ? (
					<>
						<span className="uploading">{Resources.upload}</span>
						<Progress
							percent={progress}
							showInfo={false}
						/>
					</>
				) : !!value ? (
					<img
						src={value}
						alt="avatar"
						className="image"
					/>
				) : (
					<i className="fa fa-plus icon" />
				)}
			</Upload>
		</ImgCrop>
	);
};

Component.propTypes = {
	aspect: PropTypes.number,
	onChange: PropTypes.func,
	section: PropTypes.string.isRequired,
	value: PropTypes.object,
	uploadOptions: PropTypes.object,
};

export default Component;
